import { BEConstant } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEConstantExtend {
  public static Init(dto: BEConstant) {
    dto.bEType = EnumBEType.BEConstant;
  }
}
